import { QuizAnswer } from '@/types/QuizAnswer';
import { PostgrestError } from '@supabase/supabase-js';
import localforage from 'localforage';
import { createBrowserClientSupa } from './supabase/createBrowserClient';

export const LOCAL_QUIZ_ANSWER_KEY = 'quizAnswers';

type MyReturnType = Promise<{
  data: QuizAnswer[];
  error: PostgrestError | string | null;
}>;

const getQuizAnswersFromSupa = async (): MyReturnType => {
  const supabase = createBrowserClientSupa();
  // TO-DO: Check if specifying columns could be faster
  const { data, error } = await supabase.from('quizz_answers').select('*');

  if (error) {
    return { error: 'error', data: [] };
  }
  return { error, data };
};

const getQuizAnswersFromLocal = async () => {
  // TO-DO: use zod to validate?
  try {
    const quizAnswers = ((await localforage.getItem(LOCAL_QUIZ_ANSWER_KEY)) ||
      []) as QuizAnswer[];
    return { error: false, data: quizAnswers };
  } catch (error) {
    // TO-DO: Deal with this error
    console.log('Error getting quiz answers from local:', error);
    return { error: true, data: [] };
  }
};

export const getQuizAnswers = async (userId?: string) => {
  const method = userId ? getQuizAnswersFromSupa : getQuizAnswersFromLocal;
  const { data, error } = await method();
  return { data, error };
};
